export const calculateAge = (birthdate, { maxDaysAllowed = 0 } = {}) => {
  const now = new Date();
  const age = now.getFullYear() - birthdate.getFullYear();
  const monthsDiff = now.getMonth() - birthdate.getMonth();
  const daysDiff = now.getDate() - birthdate.getDate();
  const notYet = monthsDiff < 0 || (monthsDiff === 0 && daysDiff < maxDaysAllowed);

  return notYet ? age - 1 : age;
};
